<label class="file-upload-tile" *ngIf="uploadFinished">
    <input #uploadFile type="file" multiple (change)="onChooseFiles($event)"
           accept="image/*, video/mp4, video/ogg, video/webm">
    <div class="file-upload-tile__icon">
        <mat-icon class="material-icons-round">add</mat-icon>
    </div>
    <p class="file-upload-tile__text">{{'GENERAL.ADD_NEW' | translate}}</p>
</label>
<app-loader *ngIf="!uploadFinished"></app-loader>
